<template>
  <pt-detection-package-update class="pt-detection-package-update__page"></pt-detection-package-update>
</template>

<script>
import PtDetectionPackageUpdate from 'cps/gene-product/pt-detection-package-update/withData'
export default {
  name: 'pt-detection-package-update__view',
  components: {
    'pt-detection-package-update': PtDetectionPackageUpdate
  }
}
</script>
